/**
 * Legacy Trove app used hash routes (`#/index/joininvite?…`). The React web app
 * uses BrowserRouter, so those links land on `/` with an ignored hash unless we
 * normalize them once on startup.
 *
 * Maps known legacy hash paths to first-class React Router paths.
 */
const LEGACY_HASH_PATH_MAP: Record<string, string> = {
  '/index/joininvite': '/join-invite',
  '/index/acceptinvite': '/accept-invite',
  '/index/extensionlogin': '/login',
};

export function bootstrapLegacyHashRoute(): void {
  if (typeof window === 'undefined') return;

  const rawHash = window.location.hash;
  if (!rawHash.startsWith('#/')) return;

  const hashBody = rawHash.slice(1);
  const qIndex = hashBody.indexOf('?');
  const pathPart = qIndex >= 0 ? hashBody.slice(0, qIndex) : hashBody;
  const searchPart = qIndex >= 0 ? hashBody.slice(qIndex) : '';

  const mapped = LEGACY_HASH_PATH_MAP[pathPart];
  if (!mapped) return;

  const nextUrl = `${mapped}${searchPart}`;
  window.history.replaceState(null, '', nextUrl);
}
